// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import * as echarts from 'echarts';
import '@/utils/global' //全局
import './promission' //这里进行路由后台获取的模拟
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss' // global css
import '@/assets/css/style.scss' // global css
import commonApi from "@/assets/js/common.js";
import BaiduMap from 'vue-baidu-map'
import api from '@/api/common/api.js';
import VueAreaLinkage from 'vue-area-linkage'
import store from '@/store/zhongheng/'
import "../test/unit/directives.js";


Vue.config.productionTip = false
Vue.use(ElementUI)

Vue.prototype.commonApi = commonApi;
Vue.prototype.$echarts = echarts;
Vue.use(commonApi);

Vue.use(BaiduMap, {
 // ak: 'xnOcXmxOIHCmw1ygGZ02yPADugcR85Hw'  //这个地方是官方提供的ak密钥
    ak: 'wBPtaVGyAXGmoGzEyjS8SKmt1yuOVPle'
})

window.WAPI = api;//功能人员无需关注当前接口是在哪里的，只需要调用全局API，弱化功能代码和调用API的耦合
Vue.use(VueAreaLinkage)
import scroll from 'vue-seamless-scroll'
Vue.use(scroll)

/* eslint-disable no-new */
window.vm =new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js